import type React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { useAuthStore } from 'features/auth/useAuthStore'

type Props = {
  children: React.ReactNode
}

export const AuthRequired = (props: Props) => {
  const { children } = props
  const location = useLocation()
  const authStatus = useAuthStore((state) => state.status)
  const initAuth = useAuthStore((state) => state.initAuth)
  initAuth()

  if (!location.pathname.startsWith('/auth') && authStatus === 'unauthorized') {
    return <Navigate to="/auth/login" replace={true} />
  }

  // Wait for auth to complete before rendering children
  if (authStatus !== 'ok') {
    return null
  }

  return <>{children}</>
}
